import {
  isAuthenticated,
  isClient,
  isEnterpriseAuthenticated,
} from '@cointracker/ui';

export const useAuth = (isEnterprise: boolean = false) => {
  if (!isClient()) {
    return {
      isAuthenticated: false,
    };
  }
  if (isEnterprise) {
    return {
      isAuthenticated: isEnterpriseAuthenticated(),
    };
  }
  return {
    isAuthenticated: isAuthenticated,
  };
};
